import { ArrowRight, Anchor } from "lucide-react";
import { BRAND, MEDIA } from "../lib/constants";

export const Hero = () => {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#061426] grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={MEDIA.hero}
          alt="Cargo operations at port"
          className="w-full h-full object-cover kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#061426] via-[#0B2545]/85 to-[#0B2545]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#061426] via-transparent to-transparent" />
      </div>

      {/* Hairlines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-[#C8A24A]/30" />
      <div className="hidden md:block absolute left-12 top-32 bottom-32 w-px bg-[#C8A24A]/15" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-44 md:pt-52 pb-24 min-h-screen flex flex-col justify-center">
        <div className="max-w-4xl">
          <div className="flex items-center gap-4 mb-8">
            <span className="gold-line" />
            <span className="font-sans text-[#C8A24A] uppercase text-xs tracking-widest-2">
              A Legacy Since 1970 · Cuttack, Odisha
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold leading-[1.02] tracking-tight"
          >
            Anchored in <em className="text-[#C8A24A] not-italic">Heritage.</em>
            <br />
            Engineered for <span className="italic font-medium">Cargo.</span>
          </h1>

          <p className="mt-8 max-w-2xl font-sans text-white/75 text-base md:text-lg leading-relaxed">
            {BRAND.name} is a venture born of the same legacy as Sardar Roadlines,
            Mahavir Transport and Nayak & Associates — bringing five decades of
            disciplined cargo handling, port operations and logistics expertise to
            the shores of Eastern India.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-primary-cta"
              onClick={() => scrollTo("contact")}
              className="group inline-flex items-center gap-3 bg-[#C8A24A] text-[#0B2545] font-bold px-8 py-4 uppercase text-sm tracking-widest-2 hover:bg-[#D4AF37] transition-all"
            >
              Get a Quote
              <ArrowRight
                size={16}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
            <button
              data-testid="hero-secondary-cta"
              onClick={() => scrollTo("services")}
              className="inline-flex items-center gap-3 border border-[#C8A24A] text-[#C8A24A] hover:bg-[#C8A24A] hover:text-[#0B2545] font-bold px-8 py-4 uppercase text-sm tracking-widest-2 transition-all"
            >
              Our Services
            </button>
          </div>
        </div>

        {/* Bottom anchor mark */}
        <div className="absolute bottom-10 left-6 md:left-12 right-6 md:right-12 flex items-end justify-between text-white/60">
          <div className="flex items-center gap-3 font-sans text-xs uppercase tracking-widest-2">
            <Anchor size={16} className="text-[#C8A24A]" />
            <span>Ports · Rail Sidings · Pan-India Roadways</span>
          </div>
          <div className="hidden md:block font-serif italic text-sm">
            “Built on integrity, hard work and long-term relationships.”
          </div>
        </div>
      </div>
    </section>
  );
};
